import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer"
import './doc-viewer.css'

const uri = "https://engrave-designer-frontend-docs.s3.eu-central-1.amazonaws.com/Obchodn%C3%AD+podm%C3%ADnky_Urnyo.docx"

export const Terms = () => {
  return (
    <DocViewer config={{ header: { disableHeader: true } }} pluginRenderers={DocViewerRenderers} style={{ height: document.documentElement.clientHeight-56, width: '100%' }} documents={[{ uri: uri, fileType: 'docx' }]} />
  )
}